import store from '@/store';
import mixpanel from 'mixpanel-browser';
export const useMixpanelDataIngestionHistory = (pageViewName, date, status) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        selectedDate: date,
        status: status,
    });
};
export const useMixpanelDataIngestionHistoryExport = (pageViewName, date, fileName, status) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        selectedDate: date,
        fileName: fileName,
        status: status,
    });
};
export const useMixpanelDataIngestionPagination = (pageViewName, page) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        page: page,
    });
};
